import makeStyles from 'e100-react-components/lib/styles/makeStyles';

import { Props as BoxProps } from './index';

interface Props extends Pick<BoxProps, 'spacing' | 'display' | 'justifyContent' | 'alignItems' | 'gap'> {}

const useStyles = makeStyles(({ spacing }) => ({
  container: {
    padding: (props: Props) => spacing(props.spacing || 0),
    display: (props: Props) => props.display || 'block',
    justifyContent: (props: Props) => props.justifyContent || '',
    alignItems: (props: Props) => props.alignItems || '',
    gap: (props: Props) => (props.gap !== undefined ? spacing(props.gap) : ''),
  },
}));

export default useStyles;
